import axios from 'axios';
import axiosRetry from 'axios-retry';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Axios instance for API v1
const Axios = axios.create({
  baseURL: `${BASE_URL}/api/v1`,
  timeout: 1200000,
});

// Axios instance for API v2
export const AxiosV2 = axios.create({
  baseURL: `${BASE_URL}/api/v2`,
  timeout: 1200000,
});

// Helper function to configure auth interceptor
const configureAuthInterceptor = (instance) => {
  instance.interceptors.request.use(
    async (config) => {
      try {
        // Get token from Clerk session
        const token = await window.Clerk?.session?.getToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        console.error('Error getting Clerk token:', error);
      }

      return config;
    },
    (error) => {
      console.error('Axios request interceptor error:', error);
    return Promise.reject(error);
    }
  );
};

// Helper function to configure retry logic
const configureRetry = (instance) => {
  axiosRetry(instance, {
    retries: 0,
    retryDelay: (retryCount) => retryCount * 1000,
    retryCondition: (error) => {
      return (
        axiosRetry.isNetworkOrIdempotentRequestError(error) ||
        (error.response?.status !== undefined && error.response.status >= 500)
      );
    },
  });
};

// Apply interceptors and retry logic to both instances
configureAuthInterceptor(Axios);
configureAuthInterceptor(AxiosV2);
configureRetry(Axios);
configureRetry(AxiosV2);

export default Axios;
